import {DsRuntimes} from './client/DsRuntimes'
import {getRuntimeInit} from './runtime-init'

const {boltInit, runtimeModulesForValidation} = getRuntimeInit(DsRuntimes)

export {
    boltInit,
    runtimeModulesForValidation
}
